import Vue from "vue";
import router from "@/router";
import md5 from "js-md5";
import BigNumber from "bignumber.js";
import XLSX from "xlsx-js-style";
import { handleFileConver } from "@/api/dict";

const imgApi = process.env.VUE_APP_BASE_API;
/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
      16
    );
  });
}

//获取最新token校验
export function getCheckToken(t) {
  // 加密token
  let md5Str = md5(t);
  // 重复4次
  let repeat = md5Str.repeat(4);
  // 获取当前时间，并把加密的值通过 分截取，分-秒截止
  const now = new Date();
  const timestamp = now.getTime();
  const h = now.getHours();
  const m = now.getMinutes();
  const s = now.getSeconds();
  // 如果秒小于10 则加8
  let ss = s;
  if (s < 10) {
    ss = s + 8;
  }
  let str = m + ss;
  // console.log('m:', m, ss, str)
  // 如果分-秒 小于10，则在加8
  let count = Math.abs(m - ss);
  if (count < 10) {
    str = m + ss + 8;
  }
  let token = repeat.slice(m, str);
  // 截取后再次md5
  let md5Token = md5(token);
  // console.log('token:', md5Token)
  return { timestamp, checkToken: md5Token };
}

//精度处理
export function handleAccuracyNumber(row, num1Name, num2Name) {
  var num1 = BigNumber(num1Name ? row[num1Name] || 0 : row.bankNum || 0);
  var num2 = BigNumber(num2Name ? row[num2Name] || 0 : row.serviceNum || 0);
  return num1.plus(num2).toString();
}

// 获取当前日期时间戳
export function getCurrentDateTimestamp(type) {
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1
  let day = now.getDate();
  let h = now.getHours();
  let m = now.getMinutes();
  let s = now.getSeconds();
  // 将年月日转换为字符串，并用"-"连接
  let dateStr =
    year +
    "-" +
    (month < 10 ? "0" + month : month) +
    "-" +
    (day < 10 ? "0" + day : day) +
    " " +
    h +
    ":" +
    m +
    ":" +
    s;

  // 将字符串转换为时间戳
  var timestamp = new Date(dateStr).getTime();
  // 有type 返回日期，没有返回时间戳
  if (type) {
    return dateStr;
  } else {
    return timestamp;
  }
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  let authorities = JSON.parse(sessionStorage.getItem("authorities") || "[]");
  if (authorities.length) {
    for (const i in authorities) {
      const element = authorities[i];
      if (element === key) {
        return true;
      }
    }
  }
  return false;
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 地区树形数据转换
 * @param {*} list
 *
 */
export function listToTree(list) {
  let map = {},
    node,
    tree = [],
    i;
  for (i = 0; i < list.length; i++) {
    map[list[i].areaId] = i; // 初始化映射
    list[i].children = []; // 初始化children数组
  }
  for (i = 0; i < list.length; i++) {
    node = list[i];
    if (node.parentId) {
      // 3 区县不需要children
      if (node.level == 3) {
        node.children = null;
      }
      // 如果当前节点有父节点，则找到父节点并将当前节点添加到父节点的children数组中
      list[map[node.parentId]].children.push(node);
    } else {
      // 如果当前节点没有父节点，则为树的根节点
      tree.push(node);
    }
  }
  return tree;
}

/**
 * 将数组中的parentId列表取出，倒序排列
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function idList(data, val, id = "id", children = "children") {
  let res = [];
  idListFromTree(data, val, res, id);
  return res;
}

/**
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
function idListFromTree(data, val, res = [], id = "id", children = "children") {
  for (let i = 0; i < data.length; i++) {
    const element = data[i];
    if (element[children]) {
      if (idListFromTree(element[children], val, res, id, children)) {
        res.push(element[id]);
        return true;
      }
    }
    if (element[id] === val) {
      res.push(element[id]);
      return true;
    }
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete("Authorization");
  router.options.isAddDynamicMenuRoutes = false;
}

//判断图片路径
export async function imagePrefix(data) {
  var list = JSON.parse(JSON.stringify(data));
  if (list.length) {
    var ossList = []; //判断是否为oss 路径的图片
    list.map(async (e) => {
      e.url = e.url ? e.url : e.path;
      // if (e.url.indexOf("oss") != -1) {
      ossList.push(e);
      // }
      // else {
      //   e.url = imgApi + e.url;
      // }
      return e;
    });
    if (ossList.length) {
      const paramsList = ossList.map((e) => e.url);
      const { data } = await handleFileConver({
        pathList: paramsList,
      });
      ossList.map((e, index) => {
        e.convertUrl = data[index];
        return e;
      });
    }
    ossList.map((item) => {
      list.map((listItem) => {
        if (listItem.name === item.name) {
          let originUrl = listItem.url; //原始路径
          listItem.url = item.convertUrl;
          listItem.originalUrl = originUrl;
        }
      });
    });
    return list;
  }
}

//判断两个对象是否相同
export function isEqual(obj1, obj2, hasTypeOf) {
  if (!obj1 && !obj2) return true;
  // 类型不同，直接返回 false
  if (hasTypeOf) {
    if (typeof obj1 != typeof obj2) return false;
  }
  // 特殊类型的处理
  if (obj1 == null || obj2 == null) return obj1 == obj2;
  if (Array.isArray(obj1) || Array.isArray(obj2)) {
    if (!Array.isArray(obj1) || !Array.isArray(obj2)) {
      return false;
    }
    if (obj1.length != obj2.length) {
      return false;
    }
    for (let i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i], hasTypeOf)) {
        return false;
      }
    }
    return true;
  }
  // 普通值类型的比较
  if (typeof obj1 == "object") {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length != keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (!isEqual(obj1[key], obj2[key], hasTypeOf)) {
        return false;
      }
    }
    return true;
  }
  // 普通值类型的比较
  return obj1 == obj2;
}

//表格底部合计
function sumNum(list, field) {
  let count = 0;
  list.forEach((item) => {
    count = BigNumber(0)
      .plus(count)
      .plus(item[field] ? item[field] : 0)
      .toString();
  });
  return count ? count : "";
}
export function footerMethodReduce(columns, data, list, reduceIndex) {
  const reduceSubscriptIndex = !reduceIndex ? 0 : reduceIndex;
  return [
    columns.map((column, index) => {
      if (index === reduceSubscriptIndex) {
        return "合计";
      } else if (list.includes(column.property)) {
        return sumNum(data, column.property);
      }
      return null;
    }),
  ];
}

//导出功能
export function handleExportExcel(data, header, name, hasReduce) {
  var list = JSON.parse(JSON.stringify(data));
  if (hasReduce) {
    var totalRow = {};
    hasReduce.map((e, index) => {
      totalRow[e] = index == 0 ? "合计" : sumNum(list, e);
    });
    list.push(totalRow);
  }
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(list);
  XLSX.utils.sheet_add_json(worksheet, list, {
    header: header,
  });
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${name}.xlsx`);
}

// 输入的金额进行大写转换
export function transformation(money) {
  // 汉字的数字
  const cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  // 基本单位
  const cnIntRadice = ["", "拾", "佰", "仟"];
  // 对应整数部分扩展单位
  const cnIntUnits = ["", "万", "亿", "兆"];
  // 对应小数部分单位
  const cnDecUnits = ["角", "分"];
  // 整数金额时后面跟的字符
  const cnInteger = "整";
  // 整型完以后的单位
  const cnIntLast = "元";
  // 最大处理的数字
  const maxNum = 9999999999999999.99;
  // 金额整数部分
  let integerNum;
  // 金额小数部分
  let decimalNum;
  // 输出的中文金额字符串
  let chineseStr = "";
  // 分离金额后用的数组，预定义
  let parts;
  if (money === "") {
    return "";
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    // 超出最大处理数字
    return "";
  }
  if (money === 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 转换为字符串
  money = money.toString();
  if (money.indexOf(".") === -1) {
    integerNum = money;

    decimalNum = "";
  } else {
    parts = money.split(".");
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    const IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1);
      const p = IntLen - i - 1;
      const q = p / 4;
      const m = p % 4;
      if (n === "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        // 归零
        zeroCount = 0;
        //alert(cnNums[parseInt(n)])
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m === 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  // 小数部分
  if (decimalNum !== "") {
    const decLen = decimalNum.length;
    for (let i = 0; i < decLen; i++) {
      const n = decimalNum.substr(i, 1);
      if (n !== "0") {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr === "") {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum === "") {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

// 下载图片
export function downloadFile(row) {
  let a = document.createElement("a");
  a.href = row.url;
  a.download = row.name;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// 数字每3位加逗号
export function formatNumber(num) {
  let str = Number(num).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return str;
}
